<template>
  <section class="statistic padding">
    <div class="container">
      <div class="row">
        <div class="col-4 animation a-translateY">
          <p v-if="HEADER_LANG === 'en'">For nearly twenty-five years, SolarBox has developed, implemented and financed sustainable projects that recapture and reinvest otherwise lost resources. Utilizing world-class project development expertise, SolarBox has achieved:</p>
          <p v-if="HEADER_LANG === 'ru'">На протяжении почти двадцати пяти лет SolarBox разрабатывает, внедряет и финансирует устойчивые проекты, которые возвращают и реинвестируют в противном случае потерянные ресурсы. Используя опыт разработки проектов мирового уровня, SolarBox добился:</p>
        </div>
        <div class="col-4 animation a-translateY a-tr-1">
          <div class="icon">
            <img src="../../public/static/images/home/i5.svg" alt="">
          </div>
          <div class="text">
            <span class="h2">
              $150M
            </span>
            <p  v-if="HEADER_LANG === 'en'">
              Raised for critical infrastructure over more than 5M s.f. of space.
            </p>
            <p  v-if="HEADER_LANG === 'ru'">
              Поднято для критически важной инфраструктуры более чем на 5 миллионов н.у.м. пространства.
            </p>
          </div>
        </div>
        <div class="col-4 animation a-translateY a-tr-2">
          <div class="icon">
            <img src="../../public/static/images/home/i5.svg" alt="">
          </div>
          <div class="text">
            <span class="h2">
              $210M
            </span>
            <p  v-if="HEADER_LANG === 'en'">
              Saved to our Project Partners in utility and repair expenses.
            </p>
            <p  v-if="HEADER_LANG === 'ru'">
              Экономии для наших партнеров по проектам в расходах на коммунальные услуги и ремонт.
            </p>
          </div>
        </div>
        <div class="col-4 animation a-translateY">
          <div class="icon">
            <img src="../../public/static/images/home/i6.svg" alt="">
          </div>
          <div class="text">
            <span class="h2">
              12,000+
            </span>
            <p  v-if="HEADER_LANG === 'en'">
              Equivalent of car removed from the road.
            </p>
            <p  v-if="HEADER_LANG === 'ru'">
              Эквивалент снятого с дороги автомобиля.
            </p>
          </div>
        </div>
        <div class="col-4 animation a-translateY a-tr-1">
          <div class="icon">
            <img src="../../public/static/images/home/i7.svg" alt="">
          </div>
          <div class="text">
            <span class="h2">
              24.9M
            </span>
            <p  v-if="HEADER_LANG === 'en'">
              Of saved kilowatt hours & 9.3M therms of energy since 2009.
            </p>
            <p  v-if="HEADER_LANG === 'ru'">
              Сэкономленных киловатт-часов и 9,3 млн термов энергии с 2009 года.
            </p>
          </div>
        </div>
        <div class="col-4 animation a-translateY a-tr-2">
          <div class="icon">
            <img src="../../public/static/images/home/i8.svg" alt="">
          </div>
          <div class="text">
            <span class="h2">
              3.5B
            </span>
            <p  v-if="HEADER_LANG === 'en'">
              Gallons of water saved since 2009.
            </p>
            <p  v-if="HEADER_LANG === 'ru'">
              Галлонов воды, сэкономленных с 2009 года.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'SectionStatistic',
  components: {
  },
  methods: {
  },
  computed: {
    ...mapGetters([
      'HEADER_LANG',
    ])
  },
  mounted() {
  }
}
</script>

<style scoped lang='scss'>
// Const
$cRed: #EF3527;
$cBlack: #252525;
$cYellow: #FFA630;
$cWhite: #FFFFFF;
$cGrey: rgba(55, 57, 46, .5);

//
.statistic {
  .row {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    flex: 0 0 auto;
    margin-bottom: 0 -40px;
    height: auto;
    position: relative;
    @media (max-width: 767.98px) {
      margin-bottom: 0;
    }
    .col-4 {
      flex: 0 0 33.333%;
      max-width: 33.333%;
      width: 100%;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      position: relative;
      padding: 0 40px;
      overflow: hidden;
      margin-bottom: 100px;
      &:nth-child(1n + 4) {
        margin-bottom: 0;
      }
      p {
        color: $cWhite;
      }
      .icon {
        flex: 0 0 80px;
        max-width: 80px;
        margin-top: 10px;
        img {
          max-width: 70px;
          max-height: 70px;
          object-fit: contain;
          object-position: center;
        }
        @media (max-width: 575.98px) {
          flex: 0 0 50px;
          max-width: 50px;
          margin-top: 14px;
          img {
            max-width: 40px;
            max-height: 40px;
          }
        }
      }
      .text {
        flex: 1 1 auto;
        span {
          color: $cYellow;
          display: block;
          margin-bottom: 10px;
        }
      }
      @media (max-width: 1199.98px) {
        flex: 0 0 50%;
        max-width: 50%;
        margin-bottom: 50px;
        &:nth-child(4n) {
          margin-bottom: 50px;
        }
      }
      @media (max-width: 767.98px) {
        flex: 0 0 100%;
        max-width: 100%;
        margin-bottom: 30px;
        padding: 0;
        &:nth-child(5n) {
          margin-bottom: 30px;
        }
      }
    }
  }
}
</style>
